function initMap() {
    var selector_map = $('#map');
    var data_map_x = selector_map.attr('data-map-x');
    var data_map_y = selector_map.attr('data-map-y');
    var myLatLng = new google.maps.LatLng(data_map_x, data_map_y);
    var map = new google.maps.Map(document.getElementById('map'), {
        center: myLatLng,
        zoom: 12,
        styles: [
        ],
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl:false,
        rotateControl: false,
        fullscreenControl: false
    });
    var marker = new google.maps.Marker({
        position: myLatLng,
        map: map
    });
}